import { useEffect, useState } from 'react';
import { api_getCustomMessageByCode } from '~/backend/api_calls';

export default function FooterTopBoxes() {
	const [footerBoxes, setFooterBoxes] = useState({});
	useEffect(() => {
		api_getCustomMessageByCode('footer-boxes')
			.then(json => {
				setFooterBoxes(json);
			})
			.catch(error => console.error(error));
	}, []);

	// function FooterBox(props) {
	//     return (
	//         <div className="footer-box">
	//             <h3 className="box-title"><a href={props.url}>{props.title}</a></h3>
	//             <p className="box-subtitle"><a href={props.url}>{props.subtitle}</a></p>
	//         </div>
	//     );
	// }

	//  FooterBox.propTypes = {
	//         title: PropTypes.string,
	//         subtitle: PropTypes.string
	//     };

	return (
		<div
			id="footer-top-boxes"
			dangerouslySetInnerHTML={{
				__html: footerBoxes?.bd
			}}></div>
	);
}
